import { Skeleton } from '@radix-ui/themes';
import { UserLayout } from 'components/main/layout';
import { AuthContext } from 'contexts/auth';
import { useContext } from 'react';

export const Main = () => {
  const { init } = useContext(AuthContext);

  if (!init) {
    return <Skeleton height="100vh" />;
  }

  return <UserLayout />;
};
